import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileListCheckFill.tsx
const IconFileListCheckFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M25.333 29.333H6.667a4 4 0 0 1-4-4V4c0-.736.597-1.333 1.333-1.333h18.667C23.403 2.667 24 3.264 24 4v16h5.333v5.333a4 4 0 0 1-4 4m-1.333-4v-2.666h2.667v2.666a1.333 1.333 0 1 1-2.667 0m-11.613-8.426-4.714-4.714 1.885-1.885 2.829 2.828L17.1 8.422l1.886 1.886z",
		clipRule: "evenodd"
	})]
});
var IconFileListCheckFill_default = forwardRef(IconFileListCheckFill);
//#endregion
export { IconFileListCheckFill_default as default };
